// @flow
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';

export const ModalBlock = styled.div`
  display: flex;
  flex-direction: column;
  height: 250px;
  padding: 36px;
  text-align: center;
`;

export const ModalDropZone = styled.div`
  display: flex;
  width: 60%;
  height: 40%;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: ${({ theme }) => theme.shadows.lightBlack};
  margin: auto;
  background-color: ${({ theme }) => theme.colors.terciaryL};

  :hover {
    box-shadow: ${({ theme }) => theme.shadows.extraBlack};
  }

  label {
    display: flex;
    width: 100%;
    height: 100%;
    cursor: pointer;

    p {
      margin: auto;
      ${getFont(2, 'compact')};
    }
  }

  ${maxMediaQueries.phone`
    width: 80%;
    height: 40%;
  `};
`;

export const RemoveImage = styled.span`
  display: flex;
  align-content: center;
  align-self: center;
  justify-content: center;
  padding-right: 20px;
  cursor: pointer;
`;
